/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosRequestConfig } from 'axios';
import { axios } from '../axios.config';

import { ResultsPartialTagObjectId } from '../models/ResultsPartialTagObjectId';
import { Tag } from '../models/Tag';

/* tslint:disable:no-unused-variable member-ordering max-line-length */

export class TagApiResource {

    /**
     * Create a tag
     * 
     * @param body Tag data to create
     */
    public createTag(body?: Partial<Tag>, axiosConfig?: AxiosRequestConfig): Promise<Tag> {
        const reqPath = '/v1/tag';
        let reqConfig = {
            ...axiosConfig,
            method: 'POST',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Delete an existing tag
     * 
     * @param id Tag id
     */
    public deleteTag(id: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<{}> {
        const reqPath = '/v1/tag/{id}'
                    .replace('{' + 'id}', String(id));
        let reqConfig = {
            ...axiosConfig,
            method: 'DELETE',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return tags, or query by type or search string
     * 
     * @param type tag type to filter by
     * @param q query search string
     * @param from Tag id to start from
     * @param limit Number of results to return
     */
    public findTags(query?: { type?: string, q?: string, from?: string, limit?: number }, axiosConfig?: AxiosRequestConfig): Promise<ResultsPartialTagObjectId> {
        const reqPath = '/v1/tag';
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath,
            params: query
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return a particular tag by id
     * 
     * @param id Tag id
     */
    public getTag(id: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<Tag> {
        const reqPath = '/v1/tag/{id}'
                    .replace('{' + 'id}', String(id));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return a particular tag by slug
     * 
     * @param slug Slug
     */
    public getTagBySlug(slug: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<Tag> {
        const reqPath = '/v1/tag/slug/{slug}'
                    .replace('{' + 'slug}', String(slug));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Update an existing tag
     * 
     * @param id Tag id
     * @param body Tag data to update
     */
    public updateTag(id: Partial<string>, body?: Partial<Tag>, axiosConfig?: AxiosRequestConfig): Promise<{}> {
        const reqPath = '/v1/tag/{id}'
                    .replace('{' + 'id}', String(id));
        let reqConfig = {
            ...axiosConfig,
            method: 'PATCH',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

}

export const TagApi = new TagApiResource();



// WEBPACK FOOTER //
// ./src/common/api/resources/TagApi.ts